module.exports = __webpack_public_path__ + "static/img/R-C.4d205939.gif";